import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import HalamanAkpol from "./HalamanAkpol/HalamanAkpol";
import HalamanKedinasan from "./HalamanKedinasan/HalamanKedinasan";
import Home from "./Home/Home";
import HalamanAkmil from "./HalamanAkmil/HalamanAkmil";
import HalamanBintara from "./HalamanBintara/HalamanBintara";

function App() {
  return (
    <BrowserRouter>
      <Routes>
      <Route exact path="/" element={<Home />}></Route>
      <Route exact path="/bimbel-sekolah-kedinasan" element={<HalamanKedinasan />}></Route>
      <Route exact path="/bimbel-akpol" element={<HalamanAkpol />}></Route>
      <Route exact path="/bimbel-akmil" element={<HalamanAkmil />}></Route>
      <Route exact path="/bimbel-bintara" element={<HalamanBintara />}></Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
